import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

export function useAttachmentsApi() {
  const { apiFetch } = useAuth();

  return useMemo(
    () => ({
      getAll: () => apiFetch("/attachments"),

      getById: (id) => apiFetch(`/attachments/${id}`),

      create: (formData) =>
        apiFetch("/attachments", {
          method: "POST",
          body: formData,
        }),

      update: (id, formData) =>
        apiFetch(`/attachments/${id}`, {
          method: "PUT",
          body: formData,
        }),

      remove: (id) =>
        apiFetch(`/attachments/${id}`, {
          method: "DELETE",
        }),
    }),
    [apiFetch],
  );
}
